import{isNil as n}from"./identity.js";function o(o=window){return!n(o)}function i(){return void 0!==globalThis?.process?.env?.JEST_WORKER_ID}export{o as isBrowser,i as isJestTest};
